import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=051573df&scoped=true&"
import script from "./Authorize.vue?vue&type=script&lang=js&"
export * from "./Authorize.vue?vue&type=script&lang=js&"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=051573df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051573df",
  null
  
)

export default component.exports